import styled from "styled-components";
import {
  BLACK,
  DARK_GRAY,
  LIGHT_GRAY,
  RUBIK,
  SKY_BLUE,
  WHITE,
} from "../../index.style.ts";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 30px auto;
  max-width: 560px;
  width: 100%;
`;

export const Progress = styled.div`
  display: flex;
  gap: 6px;

  span {
    flex: 1;
    height: 4px;
    border-radius: 2px;
    background: ${LIGHT_GRAY};

    &.done {
      background: ${SKY_BLUE};
    }
  }
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  h2 {
    margin: 0;
    font-family: ${RUBIK};
  }

  p {
    margin: 0;
    color: ${DARK_GRAY};
    line-height: 1.5;
  }
`;

export const Choices = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  button {
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: ${WHITE};
    border: 1px solid ${LIGHT_GRAY};
    border-radius: 12px;
    padding: 16px 18px;
    cursor: pointer;
    font: inherit;

    &:hover,
    &.selected {
      border-color: ${SKY_BLUE};
    }

    .title {
      font-family: ${RUBIK};
      font-size: 16px;
    }

    .blurb {
      font-size: 13px;
      color: ${DARK_GRAY};
    }
  }
`;

export const Uploads = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  a.button {
    background: ${WHITE};
    border: 1px solid ${BLACK};
    color: ${BLACK};
    align-self: flex-start;

    &:hover {
      border-color: ${SKY_BLUE};
      color: ${SKY_BLUE};
    }
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .done {
    font-size: 13px;
    color: #5a8b5d;
  }
`;

export const Balances = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
    color: ${DARK_GRAY};
  }

  input {
    font-family: inherit;
    font-size: 16px;
    padding: 8px 10px;
    border: 1px solid ${LIGHT_GRAY};
    border-radius: 8px;
  }
`;

export const Nav = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
`;

export const ErrorText = styled.p`
  margin: 0;
  color: #ef5350;
  font-size: 14px;
`;
